import { styled } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

export const Content = styled("div")(() => ({
  padding: "1.5rem 2rem",
  display: "flex",
  width: "100%",
  flexDirection: "row",
  justifyContent: "space-between",
  gap: "1.5rem",
}));

const styles = makeStyles(() => ({
  movementMaintenanceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 64,
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    background: "#F8FAFC",
    fontFamily: "'Manrope', sans-serif",
    padding: "15px 32px",
  },
  movementMaintenanceHeaderBreadcrumb: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  movementMaintenanceHeaderBreadcrumbTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 600,
    color: getBrandCustom("primaryColor", "#38cfc4"),
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
    "&.linkToMovements": {
      cursor: "pointer",
    },
  },
}));

export default styles;
